import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../../../../store"
import {
    getVisibleSmartlistGroups,
    areSmartlistsLoading,
    IsLoading,
    VisibileSmartlistGroups,
} from "../../selectors"
import { DispatchProps, mapDispatchToProps } from "../../actions"
import NavigationTab from "../NavigationTab"
import SmartlistChildren from "./SmartlistChildren"
import {
    TableBody,
    Row,
    Content,
    Cell,
    CellType,
    Expander,
} from "@tenforce/toolbox-table-react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { ActionType } from "@tenforce/toolbox-button-push-react"
import { INavigationSmartlistGroup, ISmartlists } from "../../index"

interface OwnProps {
    nothingFoundLabel: string
    loadMoreLabel: string
    getLabelByType: (type: string) => string
    onNavigate: () => void
}

interface StateProps extends ISmartlists, VisibileSmartlistGroups, IsLoading {}

type Props = OwnProps & StateProps & DispatchProps

export const SmartLists = ({
    filter,
    getLabelByType,
    isLoading,
    loadMoreLabel,
    nothingFoundLabel,
    smartlistGroups,
    onNavigate,
    requestSmartlistsPrivate,
    requestSmartlistsSharedByMe,
    requestSmartlistsSharedWithMe,
}: Props): JSX.Element => {
    const onLoadMore = (
        group: INavigationSmartlistGroup,
    ):
        | typeof requestSmartlistsPrivate
        | typeof requestSmartlistsSharedByMe
        | typeof requestSmartlistsSharedWithMe => {
        switch (group.type) {
            case "private":
                return requestSmartlistsPrivate
            case "sharedByMe":
                return requestSmartlistsSharedByMe
            case "sharedWithMe":
                return requestSmartlistsSharedWithMe
        }
    }
    return (
        <NavigationTab
            isLoading={isLoading}
            hasContent={
                smartlistGroups.length > 0 ||
                smartlistGroups.some((group) => group.isLoading)
            }
            nothingFoundLabel={nothingFoundLabel}
            data-ft-id="navigationPanelSmartlists"
        >
            <TableBody>
                {smartlistGroups.map((group, index) => {
                    const label = getLabelByType(group.type)

                    const notExpandedLabel = (
                        <div className="tw-truncate">
                            <span>{Symbols.Group}</span>
                            <span className="label">&nbsp;{label}</span>
                        </div>
                    )
                    const expandedLabel = (
                        <div className="tw-truncate">
                            <span>{Symbols.GroupOpened}</span>
                            <span className="label">&nbsp;{label}</span>
                        </div>
                    )

                    return (
                        <Row
                            isDefaultExpanded={filter.length > 0 || index === 0}
                            key={group.type}
                            data-ft-group={label.toLowerCase()}
                            extraClasses={`tw-mx-2 ${
                                group.isLoading ? "is-loading" : ""
                            }`}
                        >
                            <Content>
                                <Cell type={CellType.action} title={label}>
                                    <Expander
                                        extraClasses="tw-px-3"
                                        isNotExpandedLabel={notExpandedLabel}
                                        isExpandedLabel={expandedLabel}
                                        actionType={ActionType.block}
                                        data-ft-component="navigationExpander"
                                    />
                                </Cell>
                            </Content>

                            <TableBody
                                data-ft-component="navigationChildren"
                                extraClasses={`${
                                    group.isLoading ? "is-loading" : ""
                                }`}
                            >
                                <SmartlistChildren
                                    group={group}
                                    loadMoreLabel={loadMoreLabel}
                                    onNavigate={onNavigate}
                                    onLoadMore={onLoadMore(group)}
                                />
                            </TableBody>
                        </Row>
                    )
                })}
            </TableBody>
        </NavigationTab>
    )
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.navigation.smartlists,
    isLoading: areSmartlistsLoading(state.navigation),
    smartlistGroups: getVisibleSmartlistGroups(state.navigation),
})

export default connect(mapStateToProps, mapDispatchToProps)(SmartLists)
